module.exports = __webpack_public_path__ + "static/Mummy-8736a7631679e641ca1dd023f71e7f58.jpg";